import LibDateTime from "../libDateTime";
import libFloat from "../libFloat";
import { gerarPdfRecibo } from "./report-receipt-card";

export function handlePdf(invoiceData, options = {}) {
	if (!invoiceData) return;

	// Extra: nome da empresa pode vir por options, caso queira
	const empresa = options?.empresa ?? "SZ Sistemas";

	// desestrutura do jeito que vem do backend
	const { faturas, itens: itensApiRaw } = invoiceData;

	const numeroComprovante = faturas?.id_fatura;

	const dataVencimento = faturas?.data_vencimento
		? LibDateTime.formatDateInTimeZone(faturas.data_vencimento, {
				timeZone: "UTC",
				pattern: "dd/MM/yyyy",
		  })
		: "";

	const dataHora = faturas?.data_pagto ? LibDateTime.formatDateInTimeZone(faturas.data_pagto) : "";

	const titular = faturas?.nome || "—";
	const metodo = faturas?.tipo_pagto;
	const valor = libFloat.strToCurrency(faturas?.valor_fatura ?? 0);

	const itensApi = Array.isArray(itensApiRaw) ? itensApiRaw : [];

	const itens = itensApi.map((it, idx) => {
		const nome = it.nome ?? `Item ${idx + 1}`;
		const qtd = 1;
		const totalLinha = it.valor_pedido ?? it.valor ?? 0;

		return {
			nome,
			qtd,
			total: libFloat.strToCurrency(totalLinha),
		};
	});

	gerarPdfRecibo({
		numeroComprovante,
		dataHora,
		dataHoraVencimento: dataVencimento,
		estabelecimento: empresa,
		titular,
		metodo,
		valor,
		itens,
	});
}
